import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import AccommodationTextList from './AccommodationTextList'

type Props = {
  additionalPolicyNotes: Array<string>
}

const getAdditionalPolicyNoteKey = (note: string, index: number) => {
  return `${note}-${index}`
}

function AccommodationAdditionalPolicyNotes({ additionalPolicyNotes }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'zLreiOlcFhPcjLsWPTKf',
    defaultMessage: 'Please note',
    description: 'Heading for the additional policy notes section within the guest policy area of the room details modal.',
  })

  return (
    <>
      <BodyText variant="medium" weight="bold" as="h4">{heading}</BodyText>
      <AccommodationTextList items={additionalPolicyNotes} getKey={getAdditionalPolicyNoteKey} />
    </>
  )
}

export default AccommodationAdditionalPolicyNotes
